import React, {createContext, useReducer, useContext} from 'react';
import {createAsyncDispatcher, createAsyncHandler, initialAsyncState} from '../utils/asyncActionUtils';
import * as api from '../apis/api'; // api 파일에서 내보낸 모든 함수들을 불러옴

const GET_DASHBOARD = 'GET_DASHBOARD';

// DashboardContext 에서 사용 할 기본 상태
const initialState = {
    dashboard: {
        ...initialAsyncState
    }
};

const dashboardHandler = createAsyncHandler(GET_DASHBOARD, 'dashboard');

// 위에서 만든 객체 / 유틸 함수들을 사용하여 리듀서 작성
function reducer(state, action) {
    switch (action.type) {
        case GET_DASHBOARD:
        case `${GET_DASHBOARD}_SUCCESS`:
        case `${GET_DASHBOARD}_ERROR`:
            return dashboardHandler(state, action);
        default:
            throw new Error(`Unhanded action type: ${action.type}`);
    }
}

// State 용 Context 와 Dispatch 용 Context 따로 만들어주기
const DashboardStateContext = createContext(null);
const DashboardDispatchContext = createContext(null);

// 위에서 선언한 두가지 Context 들의 Provider 로 감싸주는 컴포넌트
// eslint-disable-next-line react/prop-types
export function DashboardProvider({children}) {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <DashboardStateContext.Provider value={state}>
            <DashboardDispatchContext.Provider value={dispatch}>
                {children}
            </DashboardDispatchContext.Provider>
        </DashboardStateContext.Provider>
    );
}

// State 를 쉽게 조회 할 수 있게 해주는 커스텀 Hook
export function useDashboardState() {
    const state = useContext(DashboardStateContext);

    if (!state) {
        throw new Error('Cannot find DashboardProvider');
    }

    return state;
}

// Dispatch 를 쉽게 사용 할 수 있게 해주는 커스텀 Hook
export function useDashboardDispatch() {
    const dispatch = useContext(DashboardDispatchContext);

    if (!dispatch) {
        throw new Error('Cannot find DashboardProvider');
    }

    return dispatch;
}

export const getDashboard = createAsyncDispatcher(GET_DASHBOARD, api.getDashboard);
export const getReportDashboard = createAsyncDispatcher(GET_DASHBOARD, api.getReportDashboard);
